import React from 'react';
import {Col, Row, Table} from 'reactstrap';

const sortTypes = {
	up: {
		class: 'sort-up',
	},
	down: {
		class: 'sort-down',
	},
	default: {
		class: 'sort',
	}
};

class CogsList extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			currentSort: 'default',
			sortField: '',
			isExpanded: false,
		}
	}

	onSortChange = (field) => {
		const { currentSort } = this.state;
		let nextSort;

		if (currentSort === 'down') nextSort = 'up';
		else if (currentSort === 'up') nextSort = 'default';
		else if (currentSort === 'default') nextSort = 'down';

		this.setState({
			currentSort: nextSort,
			sortField: field
		});
	};

	processData = () => {
		const {sortField, currentSort} = this.state;

		var ret = [];
		this.props.products.forEach(p => {
			if (p.Category === this.props.category) {
				ret.push(p);
			}
		});
		if (sortField === '') {
			ret.sort((a, b) => {return a.Name > b.Name ? 1 : -1});
		} else {
			switch(currentSort) {
				case 'up':
					ret.sort((a, b) => {return a[sortField] > b[sortField] ? -1 : 1});
					break;
				case 'down':
					ret.sort((a, b) => {return a[sortField] > b[sortField] ? 1 : -1});
					break;
				default:
					ret.sort((a, b) => {return a.Name > b.Name ? 1 : -1});
			}
		}
		return ret;
	}

	render() {
		const { currentSort, sortField, isExpanded } = this.state;

		var data = this.processData();
		return (
			<div className={'cogs-table'}>
                <Row>
                    <Col xs={6}>
                        Product Name
                    </Col>
                    <Col xs={3}>
                        Item Code
                    </Col>
                    <Col xs={2}>
                        Cost
                    </Col>
                </Row>
                {
                    data.map(prod => {
                        // console.log(prod)
                        return (
                            <>
                            <Row style={{padding: '15px 0'}}>
                                <Col>
                                    <Row>
                                        <Col xs={6}>
                                            {prod.Name}
                                        </Col>
                                        <Col xs={3}>
                                            {prod.Code}
                                        </Col>
                                        <Col xs={2}>
                                            ${prod.Cost}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={1}>&nbsp;</Col>
                                        <Col xs={2}>
                                            Timeframe
                                        </Col>
                                        <Col xs={2}>
                                            Quantity
                                        </Col>
                                        <Col xs={2}>
                                            {this.props.display} Cost
                                        </Col>
                                    </Row>
                                    {
                                        //now loop over all the data we have
                                        this.props.display === "Weekly" && Object.keys(prod.weeks).map((key, val) => {

                                            return (
                                                <Row>
                                                    <Col xs={1}>&nbsp;</Col>
                                                    <Col xs={2}>
                                                        { key }
                                                    </Col>
                                                    <Col xs={2}>
                                                        {prod.weeks[key].Quantity}
                                                    </Col>
                                                    <Col xs={2}>
                                                        ${prod.weeks[key].Quantity * prod.Cost}
                                                    </Col>
                                                </Row>
                                            )
                                        })
                                    }
                                    {
                                        //now loop over all the data we have
                                        this.props.display !== "Weekly" && Object.keys(prod.months).map((key, val) => {

                                            return (
                                                <Row>
                                                    <Col xs={1}>&nbsp;</Col>
                                                    <Col xs={2}>
                                                        { key }
                                                    </Col>
                                                    <Col xs={2}>
                                                        {prod.months[key].Quantity}
                                                    </Col>
                                                    <Col xs={2}>
                                                        ${prod.months[key].Quantity * prod.Cost}
                                                    </Col>
                                                </Row>
                                            )
                                        })
                                    }
                                </Col>
                            </Row>
                            </>
                        )
                    })
                }

			</div>
		);
	}
}

export default CogsList;
